<script setup lang="ts">
import Header from '@/layouts/header/ColorHeader.vue';
import Footer from '@/layouts/footer/nftFooter.vue';
import Introduction from '@/components/pages/founders/Introduction.vue';
import Differentiators from '@/components/pages/founders/Differentiators.vue';
import Timeline from "@/components/pages/founders/Timeline.vue";
import FounderNewsletter from '@/components/pages/founders/FounderNewsletter.vue';
</script>
<template>
    <!--Header-->
    <Header />
    <Introduction />
    <!-- <History /> -->
    <Differentiators />
    <Timeline/>
    <FounderNewsletter />
    <!-- <Testimonial /> -->
    <!-- <OurTeam /> -->
    <Footer />
</template>
